import "./_text-items-styles.scss";

 import './text-items';
